import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';
import { deleteSalesService } from '../../../services/salesServiceService';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllPlans = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (
    service_id: string,
    natural_key: string
  ): ActionItem[] => [
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () => navigate(`/sales/plans/edit-plan/${service_id}`)
    },
    {
      eventKey: '2',
      label: 'View',
      type: 'function',
      callback: () => navigate(`/sales/plans/view-plan/${natural_key}`)
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      callback: () => deleteSalesService(service_id),
      className: 'text-danger'
    }
  ];

  const columns = [
    { accessorKey: 'plan_id', header: 'Plan ID' },
    { accessorKey: 'service_id', header: 'Service Id' },
    { accessorKey: 'plan_name', header: 'Plan Name' },
    {
      accessorKey: 'pricing',
      header: 'Pricing',
      cell: ({ row }: { row: any }) => (
        <span>₹{parseFloat(row.original.pricing).toLocaleString()}</span>
      )
    },
    { accessorKey: 'billing_period', header: 'Billing Period' },
    { accessorKey: 'plan_type', header: 'Plan Type' },
    { accessorKey: 'tier', header: 'Tier' },
    { accessorKey: 'max_users', header: 'Max Users' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(
                row.original.plan_id,
                row.original.natural_key
              )}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useSalesPlans}
      entityName="Plans"
      columns={columns}
    />
  );
};

export default AllPlans;
